(function (module) {
    'use strict';

    function EditIntegrationCtrl($state, $scope, Integration, $stateParams, Includes, Store, $mdDialog, App, editIntegrationSave) {
        this.$onInit = () => {
            Integration
                .findById({
                    id: $stateParams.id,
                    filter: Includes.integrations,
                })
                .$promise
                .then((response) => {
                    this.integration = Store.setSingleModelData('integrations', response.id, response);
                });
        };
        this.cancel = () => {
            $state.go('root.integrations');
        };

        this.save = () => {
            return editIntegrationSave.saveIntegration({
                Integration,
                Store,
                Includes,
                integration: this.integration,
                form: this.form,
            });
        };
        this.findAppsWithIntegrationId = (integrationId) => {
            return App
                .find({
                    filter: {
                        where: { integrationId },
                        fields: ['id'],
                    },
                })
                .$promise;
        };
        this.delete = (id) => {
            this.findAppsWithIntegrationId(id).then((response) => {
                const appsUsingIntegrationCount = response && response.length;
                let modalTitle;
                let modalConfirmationText;
                let modalCancelText;
                let modalConfirmText;
                let confirmActionFunc;
                let itemCount1;

                if (appsUsingIntegrationCount > 0) {
                    modalTitle = 'You can\'t delete selected integration as it\'s used by:';

                    itemCount1 = appsUsingIntegrationCount > 0 ? `${appsUsingIntegrationCount + ' of your apps'}` : null;

                    modalConfirmationText = 'Please make sure this integration is not being used before deleting it.';
                    modalCancelText = 'Ok, I understand';
                } else {
                    modalTitle = 'Are you sure you want to permanently remove this integration?';
                    modalConfirmText = 'Yes, remove';
                    modalCancelText = 'Cancel';
                    confirmActionFunc = (id) => {
                        this.deleteById({ id });
                    };
                }
                $mdDialog.show({
                    locals: {
                        title: modalTitle,
                        confirmationText: modalConfirmationText,
                        cancelText: modalCancelText,
                        confirmText: modalConfirmText,
                        itemCount1: itemCount1,
                    },
                    controller: ($scope, $mdDialog) => {
                        $scope.cancel = () => {
                            $mdDialog.hide();
                        };
                        $scope.confirm = () => {
                            $scope.cancel();

                            confirmActionFunc(id);
                        };
                    },
                    controllerAs: '$ctrl',
                    bindToController: true,
                    templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                    parent: angular.element('body'),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                });

            });

        };
        this.deleteById = ({ id }) => {
            return Integration
                .removeById({ id })
                .$promise
                .then(() => {
                    return Store.removeSingleModelData('integrations', id);
                })
                .then(() => {
                    $state.go('root.integrations');
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

    }

    module
        .config(function ($stateProvider) {
                $stateProvider
                    .state('root.integrations.edit-integration', {
                        url: '/:id',
                        data: {
                            pageTitle: 'INTEGRATIONS_EDIT.PAGE_TITLE',
                        },
                        views: {
                            'content@root': {
                                template: '<edit-integration-component/>',
                            },
                        },
                    });
            },
        )
        .component('editIntegrationComponent', {
            templateUrl: '/js/integrations/edit-integration/edit-integration.html',
            controller: EditIntegrationCtrl,
        });

})(angular.module('rocket.components'));
